export const px2vw = (px: number): string => {
  const percent = (px / 1600 * 100);

  return `${percent.toFixed(2)}vw`;
};
